import { render, staticRenderFns } from "./student-learn.vue?vue&type=template&id=261e9fea&"
import script from "./student-learn.vue?vue&type=script&lang=js&"
export * from "./student-learn.vue?vue&type=script&lang=js&"
import style0 from "./student-learn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "student-learn.vue"
export default component.exports